// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  absent: (t, data?, options?) => t('enum.attendance-status.absent.name', data, options),
  complete: (t, data?, options?) => t('enum.attendance-status.complete.name', data, options),
  partial: (t, data?, options?) => t('enum.attendance-status.partial.name', data, options),
  /* eslint-enable max-len */
};
